import Config from '../../config';
import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Form from '../../view/form';
import Server from '../../model/refbooks/server';
import Servers from '../../collection/refbooks/servers';

import { ask, } from '../../utils/popups';
import { restrict } from '../../model/actions';
import { roleA, roleC, roleAC, roleAI } from '../../roles';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/servers.list',

    url() {
        return 'scripts/servers/list';
    },

    open() {
        const form = new Form( {
            template: 'module/refbooks/servers.form',
            clusters: this.options.clusters,
        } );

        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: restrict( roleAC, () => {
                const current = new Server();
                const binding = form.bind( current );
                binding.then( () => {
                    if (this.state().cluster && this.state().cluster.id != -1)
                        current.set( 'cluster', this.state().cluster );
                    else if (~roleC.indexOf( Config.role() ))
                        current.set( 'cluster', Config.cluster() );
                } );

                ask( binding,
                    'server::modal new - title', 'actions::create', 'actions::cancel', 
                    () => this.options.servers.save( form ) )
                        .then( () => this.options.source.reset(
                            this.options.servers.models,
                            { silent: true } // a sort of paranoia
                        ) )
                        .then( () => this.sort() )
                        .then( () => this.render() );
            } ),
            
            edit: restrict( roleAC, 

                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" servers: with cluster == my cluster;
                    // there are only global and "my" servers in the list;
                    // so, let's check only presence of cluster in server
                    // to separate "my".
                    return !!this.options.filtered
                        .current().get( 'cluster' );
                },
                
                current => {
                    current = current.clone();
                    ask( form.bind( current ),
                        'server::modal edit - title', 'actions::save', 'actions::close', 
                        () => this.options.source.save( form ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                } ),
            
            destroy: restrict( roleAC, 
                
                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" servers: with cluster == my cluster;
                    // there are only global and "my" servers in the list;
                    // so, let's check only presence of cluster in server
                    // to separate "my".
                    return !!this.options.filtered
                        .current().get( 'cluster' );
                },
                
                current => this.destroy( current, 
                    'server::modal delete - title', 
                    'server::modal delete - confirmation text' ) ),
                    
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new Servers( this.options.servers.models );
        this.options.sorted = new Servers();
        this.options.filtered = new Servers();
        this.options.paged = new Servers( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/servers.list.js